/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./invited.vue?vue&type=template&id=748bd4fb&scoped=true&"
import script from "./invited.vue?vue&type=script&lang=js&"
export * from "./invited.vue?vue&type=script&lang=js&"
import style0 from "./invited.vue?vue&type=style&index=0&id=748bd4fb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748bd4fb",
  null
  
)

export default component.exports